<template>
  <div>
    <b-row>
      <b-col>
        <moow-button
          :type="['link', 'blue']"
          :btnText="i18n_local.reviewAccomodationAgreement"
          @mClick="termsAndConditionsDialogOpened=true"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
                <md-checkbox
          v-model="lessorSignature"
          class="md-primary"
          :disabled="readonlyLocal"
        >{{lessorSignatureText}}</md-checkbox>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <md-checkbox
          v-model="lesseeSignature"
          class="md-primary"
          :disabled="readonlyLocal"
        >{{lesseeSignatureText}}</md-checkbox>
      </b-col>
    </b-row>
    <md-dialog :md-active="termsAndConditionsDialogOpened">
      <terms-and-conditions-dialog
        :hideActions="viewerHasSigned"
        termsType="accomodation"
        :params="legalParams"
        @makeDecision="onTermsAndConditionsDialogClosed"
        :requireBottom="false"
        :loading="loadingAgreementTerms"
      ></terms-and-conditions-dialog>
    </md-dialog>
  </div>
</template>
<script>
import TermsAndConditionsDialog from "@/components/dialogs/TermsAndConditions.vue";
import { mapGetters } from "vuex";

export default {
  components: { TermsAndConditionsDialog },
  props: {
    readonly: {
      type: Boolean,
      default: true,
    },
    accountId: {
      type: String,
      required: false,
    },
    lessor: {
      type: Boolean,
      required: true,
    },
    legalParams: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      termsAndConditionsDialogOpened: false,
      readonlyLocal: true, // this is used to toggle edit
      loading: true,
      params: {},
      loadingAgreementTerms: false
    };
  },
  watch: {
    'deal.signatures': function(val, oldVal) {
      if (val) {
        console.log('deal has changed');
      }
    },
  },
  filters: {},
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    deal() {
      // TODO: edit this reference depending on the Snapshot update solution.
      return this.$store.getters.dealInView;
    },
    lesseeSignature(){
      try {
        const { signatures: { accomodation: { lessee: { timestamp } = {} } = {} } = {} } = this.deal;

        return !!timestamp;
      }
      catch (err) {
        return false
      }
    },
    lessorSignature(){
      try {
        const { signatures: { accomodation: { lessor: { timestamp } = {} } = {} } = {} } = this.deal;

        return !!timestamp;
      }
      catch (err) {
        return false
      }
    },
    viewerHasSigned(){
      if(this.lessor && this.lessorSignature) return true
      if(!this.lessor && this.lesseeSignature) return true
      return false
    },
    lesseeSignatureText() {
      if (this.lesseeSignature) return this.i18n_local.tenantHasSigned;
      else return this.i18n_local.tenantHasToSign;
    },
    lessorSignatureText() {
      if (this.lessorSignature) return this.i18n_local.landlordHasSigned;
      else return this.i18n_local.landlordHasToSign;
    },
    currentUserUid() {
      if (this.$store.getters.user) return this.$store.getters.user.uid;
      else return false;
    },
  },
  created() {
    if (!this.deal) return;
    this.params = this.legalParams
  },
  methods: {
    async onTermsAndConditionsDialogClosed(decision) {
      try {
          this.loadingAgreementTerms = true
          var signerType
          if(this.lessor) signerType = "lessor"
          else signerType = "lessee"
          if (decision) {
              await this.signAgreement(signerType);
          }
          this.loadingAgreementTerms = false

      }
      catch (error) {
          console.error(error);
      }
      finally {
          this.termsAndConditionsDialogOpened = false;
      }
    },
    async signAgreement(signerType) {
      const command = {
        dealId: this.deal._id,
        signerType: signerType,
        signerAccountId: this.accountId,
        signerUid: this.currentUserUid,
        legalParams: this.legalParams,
      };

      await this.$store.dispatch("signDealAccomodationAgreement", command)
    }
  },
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>



// WEBPACK FOOTER //
// src/components/contracts/accomodationSignatures.vue